
import { TranslationRecord } from '../../types';

export const hero: TranslationRecord = {
  // Main Hero Section
  heroTitle: 'Experience Luxury in the Heart of Thessaloniki',
  heroSubtitle: 'Luxury accommodation with modern amenities, personalized service, and an ideal central location',
  exploreMore: 'Explore Our Suites',
  bookNow: 'Book Now',
  guestReviewCount: 'Over 300 guest reviews',
  awardedTo: 'Awarded to',
  travellerReviewAwards: 'Travellers\' Review Awards 2025',
  outOf10: 'out of 10',
  
  // Page-specific hero translations
  aboutHeroTitle: 'Your Home Away From Home',
  aboutHeroSubtitle: 'Discover the story behind Loena Luxury Suites and our commitment to providing exceptional hospitality in the heart of Thessaloniki.',
  contactHeroTitle: 'Get in Touch',
  contactHeroSubtitle: 'We\'re here to help make your stay in Thessaloniki unforgettable. Contact us for reservations, questions, or personalized assistance.',
  reviewsHeroTitle: 'What Our Guests Say',
  reviewsHeroSubtitle: 'Read authentic reviews from travelers who\'ve experienced the comfort and luxury of Loena Luxury Suites in the heart of Thessaloniki.',
  
  // Airbnb Badge
  guestFavorite: 'Guest Favorite',
  airbnbDescription: 'One of the most loved homes based on ratings, reviews, and reliability',
  
  // Booking Badge
  bookDirectSave: 'Book Direct Save 10%',
  
  // Key Features
  primeCityCenter: 'Prime City Center Location',
  modernAmenities: 'Modern Amenities',
  personalizedService: 'Personalized Service',
  
  // Additional hero translations
  redirectingToBooking: 'Redirecting to booking...',
  openingBookingSystem: 'Opening booking system in new tab',
  bookingError: 'Booking Error',
  enablePopups: 'Please enable popups and try again',
  navigating: 'Navigating',
  scrollingToSuites: 'Scrolling to luxury suites section',
  redirecting: 'Redirecting...',
};
